module.exports = __webpack_public_path__ + "img/poke-vue.dc429280.webp";